import { useQuery } from '@tanstack/react-query';
import { ReportInfo } from '@blisspointmedia/bpm-types/dist/Reporting';
import { awaitJSON, MiscLambdaFetch } from '@src/utils/fetch-utils';

export const useReporting = (company: string): ReturnType<typeof useQuery<ReportInfo[]>> =>
  useQuery({
    meta: { suppressGlobalError: true },
    queryKey: ['reporting', company],
    enabled: Boolean(company),
    queryFn: async (): Promise<ReportInfo[]> => {
      const res = await MiscLambdaFetch('/reporting', { params: { company } });
      return awaitJSON<ReportInfo[]>(res);
    }
  });
